import { Box, Card, CardContent, Typography, Button, Grid } from '@mui/material';
import { StatusBadge } from '@/shared/components';
import type { Job } from '../types/jobs.types';

interface JobCardProps {
  job: Job;
  onViewDetails?: (jobId: string) => void;
  onViewSummary?: (jobId: string) => void;
}

export default function JobCard({ job, onViewDetails, onViewSummary }: JobCardProps) {
  const successCount = job.results.filter((r) => !r.error).length;
  const errorCount = job.results.filter((r) => r.error).length;
  const createdAt = new Date(job.createdAt).toLocaleString('es-ES');

  return (
    <Card variant="outlined" sx={{ '&:hover': { boxShadow: 2 } }}>
      <CardContent>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            mb: 2,
          }}
        >
          <Box>
            <StatusBadge status={job.status} />
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ ml: 1, fontFamily: 'monospace' }}
            >
              {job.jobId}
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Button
              size="small"
              variant="contained"
              onClick={() => onViewDetails?.(job.jobId)}
            >
              Ver Detalles
            </Button>
            <Button
              size="small"
              variant="outlined"
              onClick={() => onViewSummary?.(job.jobId)}
            >
              Ver Resumen
            </Button>
          </Box>
        </Box>

        <Grid container spacing={2}>
          <Grid item xs={6} sm={3}>
            <Typography variant="caption" color="text.secondary" display="block">
              Idioma Destino
            </Typography>
            <Typography variant="body2" fontWeight={500}>
              {job.targetLang}
            </Typography>
          </Grid>
          <Grid item xs={6} sm={3}>
            <Typography variant="caption" color="text.secondary" display="block">
              Progreso
            </Typography>
            <Typography variant="body2" fontWeight={500}>
              {job.completed} de {job.total} ({job.progress}%)
            </Typography>
          </Grid>
          <Grid item xs={6} sm={2}>
            <Typography variant="caption" color="text.secondary" display="block">
              Exitosas
            </Typography>
            <Typography variant="body2" fontWeight={500} color="success.main">
              {successCount}
            </Typography>
          </Grid>
          <Grid item xs={6} sm={2}>
            <Typography variant="caption" color="text.secondary" display="block">
              Errores
            </Typography>
            <Typography variant="body2" fontWeight={500} color="error.main">
              {errorCount}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={2}>
            <Typography variant="caption" color="text.secondary" display="block">
              Fecha
            </Typography>
            <Typography variant="body2" fontWeight={500}>
              {createdAt}
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
